export const PRESERVE_ELEMENT_ATTRIBUTE = 'data-ds-preserve';
export const RRWEB_IFRAME_NAME = 'rrweb-replayer';

/**
 * Marks element for rrweb to preserve it on full snapshot rebuild
 */
export const preserveElementOnRebuild = (element: HTMLElement): void => {
  element.setAttribute(PRESERVE_ELEMENT_ATTRIBUTE, 'true');
};

export const getRrwebIframe = (root?: HTMLElement) => {
  const rootElem = root || document;

  return rootElem.querySelector<HTMLIFrameElement>(
    `iframe[name="${RRWEB_IFRAME_NAME}"]`
  );
};
